import { sendWebsocketMessage } from '../../../../../../App';

export function cancelAllTradePlans(){
  const msg = {
    messageType: 'cancelAllTradePlans'
  };

  sendWebsocketMessage(msg);
}
